import { render, staticRenderFns } from "./VuesticTag.vue?vue&type=template&id=4a4b5165"
import script from "./VuesticTag.vue?vue&type=script&lang=js"
export * from "./VuesticTag.vue?vue&type=script&lang=js"
import style0 from "./VuesticTag.vue?vue&type=style&index=0&id=4a4b5165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports